import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { CHECKOUT_URL } from '../utils/constants';
interface TransformCTAProps {
  label: string;
  sub: string;
  tone?: 'light' | 'dark';
}

/**
 * The transformational CTA repeated at the end of every section.
 * It restates the outcome the reader gets, then sends them to checkout.
 */
export function TransformCTA({
  label,
  sub,
  tone = 'light'
}: TransformCTAProps) {
  return <div className="mx-auto mt-10 w-full max-w-xl text-center sm:mt-12" data-id="element-322" data-mp="275qxq9qlgxn0">
      <a href={CHECKOUT_URL} className="group flex w-full items-center justify-center gap-3 rounded-2xl bg-cta px-5 py-5 text-[15.5px] font-extrabold uppercase leading-tight tracking-tight text-white shadow-[0_10px_0_-2px_rgba(19,133,62,0.55),0_18px_35px_-14px_rgba(10,37,64,0.5)] transition-[background-color,transform] duration-200 ease-out hover:bg-cta-dark active:scale-[0.985] focus-visible:outline-none focus-visible:ring-4 focus-visible:ring-cta/30 sm:text-lg" data-id="element-323" data-mp="2345ocyd9r1hk">
        <span className="text-balance" data-id="element-324" data-mp="3qq3k1ksixa05">{label}</span>
        <ArrowRightIcon className="h-5 w-5 shrink-0 transition-transform duration-200 ease-out group-hover:translate-x-1" aria-hidden="true" data-id="element-325" data-mp="3qpbuaqlly6hs" />
      </a>
      <p className={`mt-3 text-[13px] font-medium sm:text-sm ${tone === 'dark' ? 'text-white/70' : 'text-ink-soft'}`} data-id="element-326" data-mp="4iwvop9ncp3w">
        {sub}
      </p>
    </div>;
}